module.exports = __webpack_public_path__ + "img/nava-chat-icon.6b1fd6b9.svg";